import { render, staticRenderFns } from "./createMetaTag.vue?vue&type=template&id=71799fc4&scoped=true&"
import script from "./createMetaTag.vue?vue&type=script&lang=js&"
export * from "./createMetaTag.vue?vue&type=script&lang=js&"
import style0 from "./createMetaTag.vue?vue&type=style&index=0&id=71799fc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71799fc4",
  null
  
)

export default component.exports